export const value: number = 1;
export const min: number = 0;
export const max: number = 999;
export const step: number = 1;
